module.exports = __webpack_public_path__ + "static/media/10.79ec8508.png";